export default "__VITE_ASSET__CYLwvsAC__"